exports = module.exports = require("../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.windows-aio {\n  /*滑道*/\n}\n.windows-aio ::-webkit-scrollbar {\n  width: 5px;\n  height: 5px;\n  background-color: transparent;\n}\n.windows-aio ::-webkit-scrollbar-thumb {\n  background-color: rgba(0, 0, 0, 0.3);\n  border-radius: 5px;\n}\n.windows-aio ::-webkit-scrollbar-thumb:hover {\n  background-color: rgba(0, 0, 0, 0.7);\n}\n.windows-aio ::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px #333;\n          box-shadow: inset 0 0 6px #333;\n  border-radius: 5px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.28.11@css-loader?{"minimize":false,"sourceMap":false}!./~/_vue-loader@11.3.4@vue-loader/lib/style-compiler?{"id":"data-v-37efe2ea","scoped":false,"hasInlineConfig":true}!./~/_less-loader@4.0.5@less-loader/dist/cjs.js?{"sourceMap":false}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=styles&index=1!./src/App.vue
// module id = 715
// module chunks = 1